import CountriesRegionsCitiesModalView from "./countries_regions_cities_modal.html";


angular.module("countries")

    .controller("CountriesRegionsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = true //LoginService.permissionExist("CMS_CATEGORIES_WRITE");
        $rootScope.title = $filter('translate')('countries.regions');

        let filter = false;
        $scope.cityFilter = {};

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('countries.list'), url: "countries.list" },
                { title: $filter('translate')('countries.edit'), url: `countries.edit({ id: ${$scope.region.country_id}})` },
                { title: $filter('translate')('countries.region_add') },

            ];
        } else {
           
            Restangular.one('CountriesRegions', $stateParams.id).get().then(function (result) {
                $scope.region = result;
                logService.debug($scope.region);
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('countries.list'), url: "countries.list" },
                    { title: $filter('translate')('countries.edit'), url: `countries.edit({ id: ${$scope.region.country_id}})` },
                    { title: $filter('translate')('countries.region_edit') },
                ];
            });
        }

        $scope.gridCities = {
            pdfTitle: $filter('translate')('countries.regions'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                {
                    name: 'name', displayName: $filter('translate')('countries.name'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ng-click="grid.appScope.cityModal(row.entity.id)" ng-if="grid.appScope.allowWrite"', context: $scope, cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteCityDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {
                logService.debug($scope.cityFilter)

                if (filter) {
                    options.name = $scope.cityFilter.name;
                }

                options.country_region_id = $scope.region.id;

              return   Restangular.all('CountriesRegionsCities').getList(options).then(function (results) {
                    return results;
                });

            }
        };

        $scope.search = function () {
            if (angular.isDefined($scope.gridCities.loadData)) {
                filter = true;
                $scope.gridCities.loadData();
            }
        }

        $scope.cityModal = function (id: string | null = "") {

            $scope.city = {};
            id = !angular.isUndefined(id) ? $scope.city.id = id : $scope.city.id = null;

            let $modalInstance = $uibModal.open({
                animation: true,
                template: CountriesRegionsCitiesModalView,
                size: "lg",
                controller: "CountriesRegionsCitiesModalCtrl",
                scope: $scope,
                resolve: {
                    value: function () { }
                },
            });

        }

        $scope.save = function () {

            if (!angular.isUndefined($scope.region.id)) {
                $scope.region.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('countries.region_modified_success'));
                        // $state.go("countries.edit", { id: $scope.region.country_id });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('CountriesRegions').post($scope.region).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('countries.region_created_success'));
                        $scope.region = result;
                        logService.debug($scope.region)
                        // $state.go("countries.edit", { id: $scope.region.country_id });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('countries.region_delete'),
                message: $filter('translate')('countries.region_delete_message') + " " + $scope.region.name + "?",
                onAccept: function () {
                    $scope.region.remove().then(function () {
                        toastr.success($filter('translate')('countries.region_remove_success'));
                        $state.go("countries.edit", { id: $scope.region.country_id });
                    });
                }
            });
        };

        $scope.deleteCityDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('countries.city_delete'),
                message: $filter('translate')('countries.city_delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('CountriesRegionsCities', id).remove().then(function () {
                        toastr.success($filter('translate')('countries.city_remove_success'));
                        $scope.gridCities.loadData();
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                    });
                }
            });

        };



    }])

    .controller("CountriesRegionsCitiesModalCtrl", ['$scope', '$uibModalInstance', '$uibModal', '$http', 'Restangular', '$filter', 'LoginService', 'modalService', 'logService',
        function ($scope, $uibModalInstance, $uibModal, $http, Restangular, $filter, LoginService, modalService, logService) {

        $scope.modalTitle = "title";
        logService.debug("inside");

        if (angular.isUndefined($scope.city.id) || $scope.city.id == "") {

            $scope.city = { country_region_id: $scope.region.id };
            $scope.modalTitle = $filter('translate')('countries.cities_add');
            logService.debug($scope.modalTitle);
            logService.debug($scope.city)
        } else {

            $scope.modalTitle = $filter('translate')('countries.cities_edit');

            Restangular.one('CountriesRegionsCities', $scope.city.id).get().then(function (result) {
                $scope.city = result;
                logService.debug($scope.city);
            });
        }

        $scope.onAccept = function () {
            logService.debug($scope.city)

            if (!angular.isUndefined($scope.city.id)) {
                $scope.city.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('countries.city_modified_success'));
                        $scope.gridCities.loadData();
                        $scope.city = {};
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('CountriesRegionsCities').post($scope.city).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('countries.city_created_success'));
                        $scope.gridCities.loadData();
                        $scope.city = {};
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
               
            }
            $uibModalInstance.close();
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        
       

    }])

    ;

